"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.successIcon = exports.spinnerIcon = exports.notificationIcon = exports.logsIcon = exports.linkIcon = exports.infoIconActive = exports.infoIcon = exports.infoAlertIcon = exports.gatsbyIcon = exports.failedIcon = exports.exitIcon = exports.closeIcon = void 0;
var _react = _interopRequireDefault(require("react"));
const gatsbyIcon = /*#__PURE__*/_react.default.createElement("svg", {
  "aria-label": "gatsby-icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2V2ZM12 4C8.27 4 5.14 6.55 4.25 10L14 19.75C17.45 18.86 20 15.73 20 12L14.75 12V13.5H18.2C17.71 15.54 16.24 17.19 14.31 17.94L6.06 9.69C7 7.31 9.3 5.63 12 5.63C14.13 5.63 16 6.67 17.18 8.28L18.41 7.22C16.95 5.26 14.63 4 12 4ZM4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C12.04 20 12.09 20 4 12Z",
  fill: "#8A4BAF"
}));
exports.gatsbyIcon = gatsbyIcon;
const logsIcon = /*#__PURE__*/_react.default.createElement("svg", {
  width: "11",
  height: "11",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z",
  fill: "#B17ACC"
}));
exports.logsIcon = logsIcon;
const failedIcon = /*#__PURE__*/_react.default.createElement("svg", {
  style: {
    marginRight: `5px`
  },
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("circle", {
  cx: "4",
  cy: "4",
  r: "4",
  fill: "#EC1818"
}));
exports.failedIcon = failedIcon;
const infoIcon = /*#__PURE__*/_react.default.createElement("svg", {
  "aria-label": "info-icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M11 7H13L13 9H11L11 7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
  fill: "#635E69"
}));
exports.infoIcon = infoIcon;
const linkIcon = /*#__PURE__*/_react.default.createElement("svg", {
  "aria-label": "link-icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M3.9 12C3.9 10.29 5.29 8.9 7 8.9L11 8.9V7L7 7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1L7 15.1C5.29 15.1 3.9 13.71 3.9 12ZM8 13L16 13V11L8 11V13ZM17 7L13 7V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z",
  fill: "#635E69"
}));
exports.linkIcon = linkIcon;
const successIcon = /*#__PURE__*/_react.default.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.49968 1.5835C5.12967 1.5835 1.58301 5.13016 1.58301 9.50016C1.58301 13.8702 5.12967 17.4168 9.49968 17.4168C13.8697 17.4168 17.4163 13.8702 17.4163 9.50016C17.4163 5.13016 13.8697 1.5835 9.49968 1.5835ZM7.91634 13.4585L3.95801 9.50016L5.07426 8.38391L7.91634 11.2181L13.9251 5.20933L15.0413 6.3335L7.91634 13.4585Z",
  fill: "#2CA72C"
}));
exports.successIcon = successIcon;
const exitIcon = /*#__PURE__*/_react.default.createElement("svg", {
  width: "10",
  height: "10",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M11.6667 1.175L10.4917 0L5.83333 4.65833L1.175 0L0 1.175L4.65833 5.83333L0 10.4917L1.175 11.6667L5.83333 7.00833L10.4917 11.6667L11.6667 10.4917L7.00833 5.83333L11.6667 1.175Z",
  fill: "white",
  fillOpacity: "0.6"
}));
exports.exitIcon = exitIcon;
const infoIconActive = /*#__PURE__*/_react.default.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("rect", {
  width: "20",
  height: "20",
  fill: "#E5E5E5"
}), /*#__PURE__*/_react.default.createElement("rect", {
  width: "1026",
  height: "1515",
  transform: "translate(-553 -459)",
  fill: "white"
}), /*#__PURE__*/_react.default.createElement("g", {
  filter: "url(#filter0_d_1456_1573)"
}, /*#__PURE__*/_react.default.createElement("rect", {
  x: "-14",
  y: "-54",
  width: "48",
  height: "128",
  rx: "5",
  fill: "white"
})), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9 5H11L11 7H9L9 5ZM9 9H11V15H9V9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z",
  fill: "#232129"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "17",
  cy: "4",
  r: "3.5",
  fill: "#EC1818",
  stroke: "white"
}), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
  id: "filter0_d_1456_1573",
  x: "-34",
  y: "-70",
  width: "88",
  height: "168",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/_react.default.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/_react.default.createElement("feOffset", {
  dy: "4"
}), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
  stdDeviation: "10"
}), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/_react.default.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1456_1573"
}), /*#__PURE__*/_react.default.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1456_1573",
  result: "shape"
}))));
exports.infoIconActive = infoIconActive;
const notificationIcon = /*#__PURE__*/_react.default.createElement("svg", {
  width: "38",
  height: "28",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("circle", {
  cx: "5",
  cy: "0",
  r: "3.5",
  fill: "#EC1818",
  stroke: "white"
}));
exports.notificationIcon = notificationIcon;
const spinnerIcon = /*#__PURE__*/_react.default.createElement("svg", {
  "aria-label": "spinner-icon",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "28",
  height: "28"
}, /*#__PURE__*/_react.default.createElement("mask", {
  id: "mask1",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "14",
  width: "28",
  height: "14"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M14 28C21.732 28 28 21.732 28 14L-4.20265e-07 14C-1.24156e-06 21.732 6.26801 28 14 28Z",
  fill: "#232129"
})), /*#__PURE__*/_react.default.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.999 28C21.731 28 27.999 21.732 27.999 14C27.999 6.26801 21.731 0 13.999 0C6.26704 0 -0.000976562 6.26801 -0.000976562 14C-0.000976562 21.732 6.26704 28 13.999 28ZM13.9988 25.2001C20.1844 25.2001 25.1989 20.1857 25.1989 14.0001C25.1989 7.81452 20.1844 2.80011 13.9988 2.80011C7.81325 2.80011 2.79883 7.81452 2.79883 14.0001C2.79883 20.1857 7.81325 25.2001 13.9988 25.2001Z",
  fill: "#2DE3DA"
})), /*#__PURE__*/_react.default.createElement("mask", {
  id: "mask2",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "28",
  height: "28"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28ZM13.9996 25.2001C20.1852 25.2001 25.1996 20.1857 25.1996 14.0001C25.1996 7.81452 20.1852 2.80011 13.9996 2.80011C7.814 2.80011 2.79958 7.81452 2.79958 14.0001C2.79958 20.1857 7.814 25.2001 13.9996 25.2001Z",
  fill: "#2DE3DA"
})), /*#__PURE__*/_react.default.createElement("g", {
  mask: "url(#mask2)"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M14 0C6.26801 0 0 6.26801 0 14L28 14C28 6.26801 21.732 0 14 0Z",
  fill: "url(#paint0_linear)"
}))), /*#__PURE__*/_react.default.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/_react.default.createElement("circle", {
  cx: "14",
  cy: "14",
  r: "14",
  fill: "#8A4BAF"
})), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
  id: "paint0_linear",
  x1: "5.25",
  y1: "14",
  x2: "22.75",
  y2: "14",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/_react.default.createElement("stop", {
  stopColor: "#663399",
  stopOpacity: "0"
}), /*#__PURE__*/_react.default.createElement("stop", {
  offset: "1"
}))));
exports.spinnerIcon = spinnerIcon;
const closeIcon = /*#__PURE__*/_react.default.createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M11.6667 1.175L10.4917 0L5.83333 4.65833L1.175 0L0 1.175L4.65833 5.83333L0 10.4917L1.175 11.6667L5.83333 7.00833L10.4917 11.6667L11.6667 10.4917L7.00833 5.83333L11.6667 1.175Z",
  fill: "currentColor"
}));
exports.closeIcon = closeIcon;
const infoAlertIcon = /*#__PURE__*/_react.default.createElement("svg", {
  "aria-label": "info-alert-icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("circle", {
  cx: "19",
  cy: "6",
  r: "3",
  fill: "#EC1818"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 9V7H11V9H13ZM13 17V11H11V17H13ZM2 12C2 6.48 6.48 2 12 2C13.5615 2 15.0397 2.35849 16.3569 2.99759C15.847 3.44683 15.4524 4.02392 15.2234 4.67873C14.2367 4.24245 13.146 4 12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 11.2858 19.9058 10.5931 19.7293 9.93367C20.4189 9.80663 21.0466 9.5027 21.5635 9.07067C21.8473 9.99723 22 10.9809 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12Z",
  fill: "#232129"
}));
exports.infoAlertIcon = infoAlertIcon;